<template>
  <div style="width: 100%">
    <v-data-table
        :headers="headers"
        :items="items"
        :hide-default-header="empty"
        :height="items.length > 7 ? (32 * 7 + 32 + 16) : undefined"
        disable-pagination
        hide-default-footer dense
        style="white-space: nowrap"
    >
      <template v-slot:top v-if="toolbar">
        <v-toolbar flat dense>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-divider class="mx-2" inset vertical/>
          <v-btn v-if="!readonly" @click="row_create" small class="ma-2" color="primary">Add</v-btn>
          <v-spacer/>
        </v-toolbar>
      </template>
      <template v-slot:item.levelPoints="{item}">
        <div>{{ (item.levelPoints && item.levelPoints.length > 0) ? item.levelPoints.length : "-" }}</div>
      </template>
      <template v-if="!readonly" v-slot:item.actions="{item, index}">
        <v-icon @click="row_update(item, index)" class="mr-2" small>mdi-pencil</v-icon>
        <v-icon @click="row_moveup(item, index)" class="mr-2" small>mdi-arrow-up-thick</v-icon>
        <v-icon @click="row_movedown(item, index)" class="mr-2" small>mdi-arrow-down-thick</v-icon>
        <v-icon @click="row_remove(item, index)" class="mr-2" small>mdi-delete</v-icon>
      </template>
    </v-data-table>
    <r-plinko-obstacle-config-dialog ref="dialog"/>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {PlinkoObstacleConfig} from "@/modules/redactor/models/smart-offer/bundle-plinko/PlinkoObstacleConfig";

import RPlinkoObstacleConfigDialog from "@/modules/redactor/views/smart-offer/bundle-plinko/r-plinko-obstacle-config-dialog.vue";

export default {
  name: "r-plinko-obstacle-config-table",
  components: {RPlinkoObstacleConfigDialog},
  props: {
    title: VueTypes.string.isRequired,
    items: VueTypes.arrayOf(PlinkoObstacleConfig).isRequired,
    toolbar: VueTypes.bool.def(true),
    readonly: VueTypes.bool.def(false)
  },
  data: () => ({
    headers: [
      {text: 'Key', value: 'key'},
      {text: 'Level', value: 'levelPoints'},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ]
  }),
  computed: {
    empty() {
      return this.items.length === 0;
    }
  },
  methods: {
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE)
          .then((data) => {
            if (this.row_duplicate(data, -1)) {
              this.$alert("Duplicate found!");
            } else {
              this.items.push(data);
            }
          }).catch(() => {
      });
    },
    row_update(item, index) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone())
          .then((data) => {
            if (this.row_duplicate(data, index)) {
              this.$alert("Duplicate found!");
            } else if (index === this.items.indexOf(item)) {
              this.items.splice(index, 1, data);
            }
          }).catch(() => {
      });
    },
    row_remove(item, index) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        if (this.items.indexOf(item) === index) {
          this.items.splice(index, 1);
        }
      });
    },
    row_moveup(item, index) {
      if (index > 0 && this.items.indexOf(item) === index) {
        this.items.splice(index - 1, 2, this.items[index], this.items[index - 1]);
      }
    },
    row_movedown(item, index) {
      if (index < this.items.length - 1 && this.items.indexOf(item) === index) {
        this.items.splice(index, 2, this.items[index + 1], this.items[index]);
      }
    },
    row_duplicate(item, index) {
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].key === item.key && i !== index) {
          return true
        }
      }

      return false;
    }
  }
}
</script>